var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS1 = function SvgS1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M22.63 6.593a11.6 11.6 0 0 1 1.704 6.074c0 6.444-5.223 11.667-11.667 11.667S1 19.111 1 12.667C1 6.224 6.223 1 12.667 1c2.225 0 4.305.623 6.074 1.704"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19.475 12.667a6.808 6.808 0 1 1-6.808-6.808m3.889 2.919-3.889 3.89M20.445 1l-3.89 3.89v3.888h3.89l3.889-3.889h-3.89z"
  })));
};
export default SvgS1;